import React from 'react';

export const WidgetProjectsList = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 20 16">
    <g fill="none" fillRule="evenodd">
      <rect width="20" height="16" fill="#000" fillOpacity=".08" rx="2" />
      <path
        fill="#FFF"
        d="M13.273 5.367h-1.228V4.95c0-.69-.549-1.25-1.227-1.25H9.182c-.678 0-1.227.56-1.227 1.25v.417H6.727c-.677 0-1.227.56-1.227 1.25v4.166c0 .69.55 1.25 1.227 1.25h6.546c.677 0 1.227-.56 1.227-1.25V6.617c0-.69-.55-1.25-1.227-1.25zm-4.5-.417c0-.23.183-.417.409-.417h1.636c.226 0 .41.187.41.417v.417H8.772V4.95z"
      />
    </g>
  </svg>
);

export const WidgetProjectsListLarge = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
    <path
      fill="#444F5D"
      fillOpacity=".5"
      fillRule="evenodd"
      d="M20.474 9.318H18.03v-.83C18.03 7.115 16.937 6 15.587 6H12.33c-1.35 0-2.443 1.114-2.443 2.489v.829H7.443C6.094 9.318 5 10.432 5 11.807v8.295c0 1.374 1.094 2.488 2.443 2.488h13.03c1.35 0 2.444-1.114 2.444-2.488v-8.295c0-1.375-1.094-2.489-2.443-2.489zm-8.959-.83c0-.458.365-.829.815-.829h3.257c.45 0 .815.371.815.83v.829h-4.887v-.83z"
    />
  </svg>
);

export const WidgetProjectsHbar = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 20 16">
    <g fill="none" fillRule="evenodd">
      <rect width="20" height="16" fill="#000" fillOpacity=".08" rx="2" />
      <path
        fill="#FFF"
        d="M14.2 10.853a.613.613 0 0 0-.613-.613h-3.04a.613.613 0 1 0 0 1.227h3.04a.613.613 0 0 0 .613-.614zm1.493-2.346a.613.613 0 0 0-.613-.614h-3.467a.613.613 0 0 0 0 1.227h3.467a.613.613 0 0 0 .613-.613zM17.4 6.16a.613.613 0 0 0-.613-.613H11.72a.613.613 0 1 0 0 1.227h5.067a.613.613 0 0 0 .613-.614z"
      />
      <path
        fill="#EBEBEB"
        d="M10.806 5.65H4.988c-.603 0-1.091.497-1.091 1.11v3.705c0 .613.488 1.11 1.09 1.11h5.819c.602 0 1.09-.497 1.09-1.11V6.76c0-.614-.488-1.111-1.09-1.111z"
      />
      <g transform="translate(2.5 3.8)">
        <path
          fill="#FFF"
          stroke="#EBEBEB"
          strokeWidth=".5"
          d="M2.44 1.6v-.12c0-.752.599-1.362 1.34-1.362h1.455c.742 0 1.341.61 1.341 1.361v.12h.841c.742 0 1.34.611 1.34 1.362v3.704c0 .75-.598 1.36-1.34 1.36H1.599c-.742 0-1.341-.61-1.341-1.36V2.96c0-.75.6-1.361 1.34-1.361h.842zm1.227 0h1.682v-.12a.117.117 0 0 0-.114-.121H3.781a.117.117 0 0 0-.114.12v.12z"
        />
      </g>
    </g>
  </svg>
);

export const WidgetProjectsHbarLarge = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
    <g fill="none" fillRule="evenodd">
      <path
        fill="#444F5D"
        fillOpacity=".5"
        d="M22 20v-.3a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v.3a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1zm2.8-4.4v-.3a1 1 0 0 0-1-1H17a1 1 0 0 0-1 1v.3a1 1 0 0 0 1 1h6.8a1 1 0 0 0 1-1zm3.2-4.4v-.3a1 1 0 0 0-1-1h-9.8a1 1 0 0 0-1 1v.3a1 1 0 0 0 1 1H27a1 1 0 0 0 1-1z"
      />
      <g transform="translate(1 7)">
        <path
          fill="#A1A7AE"
          stroke="#FFF"
          d="M3.842 2.448v-.237C3.842.715 5.035-.5 6.512-.5h2.895c1.478 0 2.671 1.215 2.671 2.711v.237h1.671c1.477 0 2.671 1.216 2.671 2.711v7.37c0 1.496-1.194 2.712-2.67 2.712H2.17C.695 15.24-.5 14.025-.5 12.53V5.16c0-1.496 1.194-2.712 2.67-2.712h1.672zm2.447 0h3.342v-.237a.23.23 0 0 0-.224-.237H6.513a.23.23 0 0 0-.224.237v.237z"
        />
      </g>
    </g>
  </svg>
);

export const WidgetUsersList = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 20 16">
    <g fill="none" fillRule="evenodd">
      <rect width="20" height="16" fill="#000" fillOpacity=".08" rx="2" />
      <path
        fill="#FFF"
        d="M9.817 7.885a2.082 2.082 0 1 1 0-4.163 2.082 2.082 0 0 1 0 4.163zm-.062.48c1.507.004 2.597.847 3.27 2.53a1 1 0 0 1-.93 1.371H7.413a1 1 0 0 1-.93-1.37c.672-1.69 1.763-2.534 3.272-2.53z"
      />
    </g>
  </svg>
);

export const WidgetUsersListStandalone = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
    <path
      fill="#444F5D"
      fillOpacity=".5"
      fillRule="evenodd"
      d="M13.876 13.962a3.98 3.98 0 1 1 0-7.962 3.98 3.98 0 0 1 0 7.962zm-.12.918c3.258.008 5.496 2.066 6.714 6.176a1 1 0 0 1-.959 1.284H8a1 1 0 0 1-.96-1.283c1.218-4.125 3.457-6.184 6.716-6.177z"
    />
  </svg>
);

export const WidgetUsersHbar = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 20 16">
    <g fill="none" fillRule="evenodd">
      <rect width="20" height="16" fill="#000" fillOpacity=".08" rx="2" />
      <path
        fill="#FFF"
        d="M13.143 10.771a.657.657 0 0 0-.657-.657H9.229a.657.657 0 1 0 0 1.315h3.257a.657.657 0 0 0 .657-.658zm1.6-2.514a.657.657 0 0 0-.657-.657H10.37a.657.657 0 1 0 0 1.314h3.715a.657.657 0 0 0 .657-.657zm1.828-2.514a.657.657 0 0 0-.657-.657h-5.428a.657.657 0 1 0 0 1.314h5.428a.657.657 0 0 0 .657-.657z"
      />
      <g transform="translate(4 4)">
        <path
          fill="#FFF"
          stroke="#EBEBEB"
          d="M3.347 4.376a2.438 2.438 0 1 1 0-4.876 2.438 2.438 0 0 1 0 4.876zm-.057-.553c1.582.003 2.754.88 3.457 2.549a1.5 1.5 0 0 1-1.382 2.082H1.211a1.5 1.5 0 0 1-1.383-2.08C.53 4.698 1.705 3.819 3.29 3.823z"
        />
      </g>
    </g>
  </svg>
);

export const WidgetUsersHbarStandalone = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
    <g fill="none" fillRule="evenodd">
      <path
        fill="#444F5D"
        fillOpacity=".5"
        d="M19 19v-.3a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v.3a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1zm2.8-4.4v-.3a1 1 0 0 0-1-1H14a1 1 0 0 0-1 1v.3a1 1 0 0 0 1 1h6.8a1 1 0 0 0 1-1zm3.2-4.4v-.3a1 1 0 0 0-1-1h-9.8a1 1 0 0 0-1 1v.3a1 1 0 0 0 1 1H24a1 1 0 0 0 1-1z"
      />
      <g transform="translate(3 7)">
        <path
          fill="#A1A7AE"
          stroke="#FFF"
          d="M5.857 7.282a3.891 3.891 0 1 1 0-7.782 3.891 3.891 0 0 1 0 7.782zm-.1-.217c2.96.007 5.022 1.85 6.133 5.408a1.5 1.5 0 0 1-1.432 1.947H1.051A1.5 1.5 0 0 1-.38 12.474C.73 8.903 2.793 7.06 5.756 7.065z"
        />
      </g>
    </g>
  </svg>
);

export const WidgetLabelsHbar = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16">
    <g fill="none" fillRule="evenodd">
      <rect width="20" height="16" fill="#000" fillOpacity=".08" rx="2" />
      <path
        fill="#FFF"
        d="M13.214 10.771a.657.657 0 0 0-.657-.657H9.3a.657.657 0 1 0 0 1.315h3.257a.657.657 0 0 0 .657-.658zm1.6-2.514a.657.657 0 0 0-.657-.657h-3.714a.657.657 0 0 0 0 1.314h3.714a.657.657 0 0 0 .657-.657zm1.829-2.514a.657.657 0 0 0-.657-.657h-5.429a.657.657 0 0 0 0 1.314h5.429a.657.657 0 0 0 .657-.657z"
      />
      <g transform="translate(3.5 4)">
        <path
          fill="#FFF"
          stroke="#EBEBEB"
          d="M5.167 1.917a.917.917 0 1 1 1.833 0 .917.917 0 0 1-1.833 0zM2.399 8.159L-.159 5.601A1.156 1.156 0 0 1-.16 3.962L3.887-.112c.256-.256.6-.393.946-.388h2.34C7.906-.5 8.5.094 8.5.827v2.332c.005.355-.132.698-.39.956L4.04 8.159a1.157 1.157 0 0 1-1.64 0zM5.5 1.917a.583.583 0 1 0 1.167 0 .583.583 0 0 0-1.167 0z"
        />
      </g>
    </g>
  </svg>
);

export const WidgetLabelsHbarStandalone = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
    <g fill="none" fillRule="evenodd">
      <path
        fill="#444F5D"
        fillOpacity=".5"
        d="M20 19v-.3a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v.3a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1zm2.8-4.4v-.3a1 1 0 0 0-1-1H15a1 1 0 0 0-1 1v.3a1 1 0 0 0 1 1h6.8a1 1 0 0 0 1-1zm3.2-4.4v-.3a1 1 0 0 0-1-1h-9.8a1 1 0 0 0-1 1v.3a1 1 0 0 0 1 1H25a1 1 0 0 0 1-1z"
      />
      <g transform="translate(3 7)">
        <path
          fill="#A1A7AE"
          stroke="#FFF"
          d="M9.417 3.354a1.23 1.23 0 1 1 2.459 0 1.23 1.23 0 0 1-2.46 0zm-4.952 10.66L-.013 9.536a1.649 1.649 0 0 1-.003-2.338L7.067.07A1.93 1.93 0 0 1 8.459-.5h4.094c1.075 0 1.947.872 1.947 1.947v4.087a1.936 1.936 0 0 1-.57 1.4l-7.127 7.08a1.649 1.649 0 0 1-2.338 0zM9.25 3.354a1.396 1.396 0 1 0 2.791 0 1.396 1.396 0 0 0-2.79 0z"
        />
      </g>
    </g>
  </svg>
);

export const WidgetLabelsList = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 20 16">
    <g fill="none" fillRule="evenodd">
      <rect width="20" height="16" fill="#000" fillOpacity=".08" rx="2" />
      <path
        fill="#FFF"
        d="M11.467 5.917a.417.417 0 1 0 .833 0 .417.417 0 0 0-.833 0zm-2.913 5.89a.657.657 0 0 0 .931 0l4.073-4.047a.82.82 0 0 0 .242-.593v-2.34A.827.827 0 0 0 12.973 4h-2.34a.82.82 0 0 0-.593.242L5.994 8.315a.657.657 0 0 0 0 .931l2.56 2.56zm2.246-5.89a1.083 1.083 0 1 1 2.167 0 1.083 1.083 0 0 1-2.167 0z"
      />
    </g>
  </svg>
);

export const WidgetLabelsListStandalone = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
    <path
      fill="#444F5D"
      fillOpacity=".5"
      fillRule="evenodd"
      d="M17.333 9.833a.834.834 0 1 0 1.668 0 .834.834 0 0 0-1.668 0zm-5.826 11.78a1.313 1.313 0 0 0 1.863 0l8.146-8.093A1.64 1.64 0 0 0 22 12.333v-4.68C22 6.74 21.26 6 20.347 6h-4.68c-.43-.006-.86.157-1.187.484L6.388 14.63a1.313 1.313 0 0 0 0 1.863l5.119 5.12zM16 9.832a2.166 2.166 0 1 1 4.333 0 2.166 2.166 0 0 1-4.333 0z"
    />
  </svg>
);

export const WidgetClientsHbar = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 20 16">
    <g fill="none" fillRule="evenodd">
      <rect width="20" height="16" fill="#000" fillOpacity=".08" rx="2" />
      <path
        fill="#FFF"
        d="M14.2 10.853a.613.613 0 0 0-.613-.613h-3.04a.613.613 0 1 0 0 1.227h3.04a.613.613 0 0 0 .613-.614zm1.493-2.346a.613.613 0 0 0-.613-.614h-3.467a.613.613 0 0 0 0 1.227h3.467a.613.613 0 0 0 .613-.613zM17.4 6.16a.613.613 0 0 0-.613-.613H11.72a.613.613 0 1 0 0 1.227h5.067a.613.613 0 0 0 .613-.614z"
      />
      <path
        fill="#EBEBEB"
        d="M10.806 5.65H4.988c-.603 0-1.091.497-1.091 1.11v3.705c0 .613.488 1.11 1.09 1.11h5.819c.602 0 1.09-.497 1.09-1.11V6.76c0-.614-.488-1.111-1.09-1.111z"
      />
      <g transform="translate(2.5 3.8)">
        <path
          fill="#FFF"
          stroke="#EBEBEB"
          strokeWidth=".5"
          d="M2.44 1.6v-.12c0-.752.599-1.362 1.34-1.362h1.455c.742 0 1.341.61 1.341 1.361v.12h.841c.742 0 1.34.611 1.34 1.362v3.704c0 .75-.598 1.36-1.34 1.36H1.599c-.742 0-1.341-.61-1.341-1.36V2.96c0-.75.6-1.361 1.34-1.361h.842zm1.227 0h1.682v-.12a.117.117 0 0 0-.114-.121H3.781a.117.117 0 0 0-.114.12v.12z"
        />
      </g>
    </g>
  </svg>
);

export const WidgetClientsHbarStandalone = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
    <g fill="none" fillRule="evenodd">
      <path
        fill="#444F5D"
        fillOpacity=".5"
        d="M19 19v-.3a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v.3a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1zm2.8-4.4v-.3a1 1 0 0 0-1-1H14a1 1 0 0 0-1 1v.3a1 1 0 0 0 1 1h6.8a1 1 0 0 0 1-1zm3.2-4.4v-.3a1 1 0 0 0-1-1h-9.8a1 1 0 0 0-1 1v.3a1 1 0 0 0 1 1H24a1 1 0 0 0 1-1z"
      />
      <g transform="translate(3 7)">
        <path
          fill="#A1A7AE"
          stroke="#FFF"
          d="M5.9 12.099l2.843-4.264.422.316c1.204.901 2.108 2.346 2.725 4.322a1.5 1.5 0 0 1-1.432 1.947H1.051A1.5 1.5 0 0 1-.38 12.474c.652-2.097 1.627-3.598 2.938-4.483l.417-.282L5.9 12.1zm-.043-4.817a3.891 3.891 0 1 1 0-7.782 3.891 3.891 0 0 1 0 7.782z"
        />
      </g>
      <path fill="#A1A7AE" d="M7.5 15h2.8l-1.4 3.241z" />
    </g>
  </svg>
);

export const WidgetHoursLine = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 20 16">
    <g fill="none" fillRule="evenodd">
      <rect width="20" height="16" fill="#000" fillOpacity=".08" rx="2" />
      <path
        fill="#FFF"
        d="M6.8 8a.8.8 0 0 1 .8.8v2.4a.8.8 0 1 1-1.6 0V8.8a.8.8 0 0 1 .8-.8zM10 5.6a.8.8 0 0 1 .8.8v4.8a.8.8 0 1 1-1.6 0V6.4a.8.8 0 0 1 .8-.8zM13.2 4a.8.8 0 0 1 .8.8v6.4a.8.8 0 1 1-1.6 0V4.8a.8.8 0 0 1 .8-.8z"
      />
    </g>
  </svg>
);

export const WidgetHoursLineStandalone = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
    <path
      fill="#444F5D"
      fillOpacity=".5"
      fillRule="evenodd"
      d="M7 14h1.2a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1zm6.4-4.8h1.2a1 1 0 0 1 1 1V21a1 1 0 0 1-1 1h-1.2a1 1 0 0 1-1-1V10.2a1 1 0 0 1 1-1zM19.8 6H21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-1.2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1z"
    />
  </svg>
);

export const WidgetHoursCumulativeLine = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
    <g fill="none" fillRule="evenodd">
      <path
        fill="#A1A7AE"
        fillOpacity=".353"
        d="M4.243 15.754c4.95.024 8.866-.773 11.75-2.39 2.886-1.619 5.435-3.933 7.65-6.943v14.534h-19.4v-5.201z"
      />
      <path stroke="#A1A7AE" strokeLinecap="round" strokeWidth="1.5" d="M5 21h18" />
      <path
        stroke="#A1A7AE"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M5.243 15.754c4.496.024 8.055-.773 10.675-2.39 2.621-1.619 4.938-3.933 6.95-6.943"
      />
      <circle cx="5.5" cy="15.8" r="1.5" fill="#A1A7AE" stroke="#FFF" />
      <circle cx="15.5" cy="13.5" r="1.5" fill="#A1A7AE" stroke="#FFF" />
      <circle cx="22.5" cy="7" r="1.5" fill="#A1A7AE" stroke="#FFF" />
    </g>
  </svg>
);

export const WidgetDonutChartIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.50031 0.0155764C7.77592 -0.00167106 8 0.223814 8 0.499957V1.53996C8 1.8161 7.77575 2.03778 7.50058 2.06092C6.90708 2.11083 6.32437 2.24942 5.77196 2.47208C5.51584 2.57531 5.2158 2.47834 5.09147 2.23177L4.62322 1.30314C4.49889 1.05657 4.59746 0.754341 4.85131 0.645655C5.6918 0.285803 6.58782 0.0726812 7.50031 0.0155764ZM3.32853 1.50554C3.55271 1.34429 3.86243 1.41597 4.00936 1.64978L4.56273 2.53034C4.70966 2.76414 4.63773 3.07116 4.41705 3.23716C3.45099 3.96389 2.72533 4.97011 2.34257 6.1251C1.95981 7.28009 1.94093 8.52053 2.28179 9.68037C2.35965 9.94531 2.23399 10.2345 1.97651 10.3343L1.00679 10.7101C0.749302 10.8099 0.458074 10.6824 0.374562 10.4192C-0.134161 8.81585 -0.125686 7.08815 0.406136 5.48337C0.937957 3.87858 1.96295 2.48776 3.32853 1.50554ZM1.31336 11.3968C1.06716 11.5219 0.967629 11.8238 1.10783 12.0617C1.99257 13.5631 3.34639 14.7388 4.9674 15.4029C6.58841 16.0669 8.37802 16.1789 10.0618 15.7297C10.3286 15.6585 10.4695 15.3736 10.3818 15.1117L10.0515 14.1255C9.96383 13.8637 9.68077 13.7247 9.41249 13.7902C8.1944 14.0873 6.9088 13.9936 5.74072 13.5151C4.57263 13.0366 3.59077 12.2015 2.93124 11.1351C2.78598 10.9003 2.48677 10.8007 2.24057 10.9258L1.31336 11.3968ZM11.8976 14.9863C11.6565 15.1208 11.357 15.0142 11.2378 14.7651L10.7888 13.827C10.6696 13.5779 10.7762 13.2811 11.0144 13.1415C11.9972 12.5653 12.7976 11.7173 13.3159 10.695C13.9098 9.52346 14.1001 8.18858 13.8572 6.89779C13.6143 5.607 12.9518 4.43259 11.9727 3.5571C11.1183 2.79306 10.0644 2.29401 8.93942 2.11445C8.66673 2.07093 8.45957 1.8332 8.48009 1.55782L8.55738 0.520697C8.5779 0.245318 8.81812 0.0371085 9.09168 0.0747867C10.6652 0.291514 12.1428 0.972593 13.3325 2.03639C14.6468 3.21155 15.536 4.78793 15.862 6.52054C16.188 8.25314 15.9326 10.0449 15.1354 11.6174C14.4138 13.0409 13.2848 14.2124 11.8976 14.9863Z"
    />
  </svg>
);

export const WidgetTableIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.33333 0H14.6667C15.403 0 16 0.596954 16 1.33333V14.6667C16 15.403 15.403 16 14.6667 16H1.33333C0.596954 16 0 15.403 0 14.6667V1.33333C0 0.596954 0.596954 0 1.33333 0ZM7 5.33333H1.66667C1.48257 5.33333 1.33333 5.48257 1.33333 5.66667V9C1.33333 9.18409 1.48257 9.33333 1.66667 9.33333H7C7.1841 9.33333 7.33333 9.18409 7.33333 9V5.66667C7.33333 5.48257 7.1841 5.33333 7 5.33333ZM9 5.33333H14.3333C14.5174 5.33333 14.6667 5.48257 14.6667 5.66667V9C14.6667 9.18409 14.5174 9.33333 14.3333 9.33333H9C8.81591 9.33333 8.66667 9.18409 8.66667 9V5.66667C8.66667 5.48257 8.81591 5.33333 9 5.33333ZM14.6667 3.66667V1.66667C14.6667 1.48257 14.5174 1.33333 14.3333 1.33333H1.66667C1.48257 1.33333 1.33333 1.48257 1.33333 1.66667V3.66667C1.33333 3.85076 1.48257 4 1.66667 4H14.3333C14.5174 4 14.6667 3.85076 14.6667 3.66667ZM1.66667 10.6667H7C7.1841 10.6667 7.33333 10.8159 7.33333 11V14.3333C7.33333 14.5174 7.1841 14.6667 7 14.6667H1.66667C1.48257 14.6667 1.33333 14.5174 1.33333 14.3333V11C1.33333 10.8159 1.48257 10.6667 1.66667 10.6667ZM8.66667 11V14.3333C8.66667 14.5174 8.81591 14.6667 9 14.6667H14.3333C14.5174 14.6667 14.6667 14.5174 14.6667 14.3333V11C14.6667 10.8159 14.5174 10.6667 14.3333 10.6667H9C8.81591 10.6667 8.66667 10.8159 8.66667 11Z"
    />
  </svg>
);

export const WidgetBarChartIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 1C14.4477 1 14 1.44772 14 2V14C14 14.5523 14.4477 15 15 15C15.5523 15 16 14.5523 16 14V2C16 1.44772 15.5523 1 15 1ZM7 3.8C6.44772 3.8 6 4.24771 6 4.8V14C6 14.5523 6.44772 15 7 15C7.55228 15 8 14.5523 8 14V4.8C8 4.24772 7.55228 3.8 7 3.8ZM3 8.46667C2.44772 8.46667 2 8.91438 2 9.46667V14C2 14.5523 2.44772 15 3 15C3.55228 15 4 14.5523 4 14V9.46667C4 8.91438 3.55228 8.46667 3 8.46667ZM10 7.6C10 7.04772 10.4477 6.6 11 6.6C11.5523 6.6 12 7.04772 12 7.6V14C12 14.5523 11.5523 15 11 15C10.4477 15 10 14.5523 10 14V7.6Z"
    />
  </svg>
);

export const WidgetDragHandleIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="9" cy="5" r="2" transform="rotate(-90 9 5)" />
    <circle cx="9" cy="12" r="2" transform="rotate(-90 9 12)" />
    <circle cx="9" cy="19" r="2" transform="rotate(-90 9 19)" />
    <circle cx="15" cy="5" r="2" transform="rotate(-90 15 5)" />
    <circle cx="15" cy="12" r="2" transform="rotate(-90 15 12)" />
    <circle cx="15" cy="19" r="2" transform="rotate(-90 15 19)" />
  </svg>
);
